import { Route } from "react-router-dom";

interface propTypes {
    children?: React.ReactNode,
    key: any
    path: string
    exact : boolean,
    component: React.ElementType<any>,
}

const PublicRoute = (props: propTypes ) => {

    const { component: Component} = props

    return (
        <Route exact={props.exact} path={props.path}>
            <Component/>
        </Route>
    )

}


export default PublicRoute